module.exports = __webpack_public_path__ + "img/my_message_bg.117e7626.png";